import utils from "../../../utils/utils.js";

export default {
    async fetchFilterOption(context,payload) {
        const languageId = payload.languageId;

        const responseData = await utils.utility.fetch(`api/editor/getfilters?langid=${languageId}&isignorelist=true`, "GET", null, null);

        context.commit("setFilterOption", responseData.data);
    },
    async fetchDayFilter(context) {
        const responseData = await utils.utility.fetch(`api/editor/getsolrfilters?filterkeyname=feeddateday&isignorelist=true`, "GET", null, null, true);
        
        context.commit("setDayFilter", responseData);
    },
    async fetchMonthFilter(context) {
        const responseData = await utils.utility.fetch(`api/editor/getsolrfilters?filterkeyname=feeddatemonth&isignorelist=true`, "GET", null, null, true);
        
        context.commit("setMonthFilter", responseData);
    },
    async fetchYearFilter(context) {
        const responseData = await utils.utility.fetch(`api/editor/getsolrfilters?filterkeyname=feeddateyear&isignorelist=true`, "GET", null, null, true);
        
        context.commit("setYearFilter", responseData);
    },
    async fetchLangFilter(context) {
        const responseData = await utils.utility.fetch(`api/editor/getsolrfilters?filterkeyname=lang&isignorelist=true`, "GET", null, null, true);
        
        context.commit("setLangFilter", responseData);
    },
    async fetchTypeFilter(context) {
        const responseData = await utils.utility.fetch(`api/editor/getsolrfilters?filterkeyname=feedtype&isignorelist=true`, "GET", null, null, true);
        
        context.commit("setTypeFilter", responseData);
    },
    async fetchKeywordFilter(context) {
        const responseData = await utils.utility.fetch(`api/editor/getsolrfilters?filterkeyname=keywordtext&isignorelist=true`, "GET", null, null, true);
        
        context.commit("setKeywordFilter", responseData);
    },
    async fetchChannelFilter(context) {
        const responseData = await utils.utility.fetch(`api/editor/getsolrfilters?filterkeyname=sourcetype&isignorelist=true`, "GET", null, null, true);
        
        context.commit("setChannelFilter", responseData);
    },
    async fetchPublisherFilter(context) {
        const responseData = await utils.utility.fetch(`api/editor/getsolrfilters?filterkeyname=publishername&isignorelist=true`, "GET", null, null, true);
        
        context.commit("setPublisherFilter", responseData);
    },
    async fetchSentimentFilter(context) {
        const responseData = await utils.utility.fetch(`api/editor/getsolrfilters?filterkeyname=sentiment&isignorelist=true`, "GET", null, null, true);
        
        context.commit("setSentimentFilter", responseData);
    },
    async fetchIrrelativeFilter(context) {
        const responseData = await utils.utility.fetch(`api/editor/getsolrfilters?filterkeyname=irrelative&isignorelist=true`, "GET", null, null, true);
        
        context.commit("setIrrelativeFilter", responseData);
    },
    async fetchSourceFilter(context) {
        const responseData = await utils.utility.fetch(`api/editor/getsolrfilters?filterkeyname=sourcename&isIgnoreList=true`, "GET", null, null, true);
        
        context.commit("setSourceFilter", responseData);
    },
    async fetchMainCatFilter(context) {
        const responseData = await utils.utility.fetch(`api/editor/getsolrfilters?filterkeyname=opcommentid&isignorelist=true`, "GET", null, null, true);
        
        context.commit("setMainCatFilter", responseData);
    },
    async fetchSubCatFilter(context) {
        const responseData = await utils.utility.fetch(`api/editor/getsolrfilters?filterkeyname=opstatusid&isignorelist=true`, "GET", null, null, true);
        
        context.commit("setSubCatFilter", responseData);
    },
    async fetchDetailCatFilter(context) {
        const responseData = await utils.utility.fetch(`api/editor/getsolrfilters?filterkeyname=optypeid&isignorelist=true`, "GET", null, null, true);
        
        context.commit("setDetailCatFilter", responseData);
    }
}